// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4c039cb3","239":"82d68367","453":"cf5b1130","732":"14d5e833"}[chunkId] + ".chunk.js";
};